import { Component, Input, Output, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription, Observable, map } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import { File } from '@core/objects/file';
import { Organization } from '@core/objects/organization';

import { AppService } from '@app/services/app/app.service';
import { SettingsOrganizationService } from '@app/services/settings/organization.service';

@Component({
    selector: 'organization-profile-logo-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class OrganizationProfileLogoMainComponent implements OnInit, OnDestroy{
    // access not required because is not in a specific route or screen
    // private readonly ACCESS = 'access_setting_organization_profile'; 

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 2;

    public readonly VIEW_MAIN   = "main";
    public readonly VIEW_UPLOAD = "upload";
    public readonly VIEW_EDIT   = "edit";

    public readonly RESPONSE_ERROR_FORBIDDEN = 403;
    public readonly MODAL_VIEW_NONE = 0;
    public readonly MODAL_VIEW_LOGO_UPLOAD_ERROR = 1;
    public readonly MODAL_VIEW_LOGO_DELETE_ERROR = 2;

    uploadStatus$ : Observable<number>; 
    deleteStatus$ : Observable<number>;
    errorActions$: Observable<HttpErrorResponse>;  

    @Input() org: Organization;
    @Input() logo: any;
    @Output() clickCancel = new EventEmitter();
    @Output() clickSave = new EventEmitter();

    public view: string = this.VIEW_MAIN;
    public modalView: number = this.MODAL_VIEW_NONE;
    public file: File = null;
    public options: any = {};
    private backupOptions: any = {};
    public working2: boolean = true;
    public working: boolean = false;


    protected uploadStatusSubscriptor$: Subscription;
    protected deleteStatusSubscriptor$: Subscription;
	constructor(private appSrv: AppService, private orgSrv: SettingsOrganizationService){}

	ngOnInit(){

        this.uploadStatus$ = this.orgSrv.selectUploadStatus(); // Use the service method
        this.deleteStatus$ = this.orgSrv.selectDeleteStatus(); // Use the service method        
        this.errorActions$ = this.orgSrv.selectErrorActions(); // Use the service method

        // get file from curretn session
        if(this.logo != null){
            this.file = this.logo.file;
            this.options = this.logo.options;
            this.backupOptions = {...this.options}
        }
        // Subscribe to uploadStatus$ and trigger reload/refresh when done
        this.uploadStatusSubscriptor$ =  this.orgSrv.selectUploadStatus().subscribe(status => {
            switch (status) {
                case 1: // Loading
                    this.working = true;
                    break;
                case 2: // Done
                case 0: // Assuming 0 is also a "Done" state
                    this.working = false;
                    break;
                case 3: // Error
                    this.working = false;
                    this.modalView = this.MODAL_VIEW_LOGO_UPLOAD_ERROR;
                    break;
            }
        });

        this.deleteStatusSubscriptor$ = this.orgSrv.selectDeleteStatus().subscribe(status => {
            switch (status) {
                // loading does not affect
                case 2: // Done
                case 0: // Assuming 0 is also a "Done" state
                    if(this.working){
                        this.working = false;   
                        this.file = null;
                        this.options = {};
                
                        this.appSrv.init(); 
                    }
                    break;
                case 3: // Error
                    this.working = false;
                    this.modalView = this.MODAL_VIEW_LOGO_DELETE_ERROR;
                    break;
            }
            
        });
    }

    ngOnDestroy(): void {
        this.uploadStatusSubscriptor$.unsubscribe();
        this.deleteStatusSubscriptor$.unsubscribe();
    }

    onError(){
        this.orgSrv.clearActionFailures();
        this.modalView = this.MODAL_VIEW_NONE;
    }

    show(area: string) {
        this.view = area;
    }

    cancel() {
        // console.log("cancel");
        this.clickCancel.emit();
        this.options = {...this.backupOptions};
    }

    delete() {
        // TODO: check what to do after this call.
        this.working = true
        this.orgSrv.deleteLogo();
    }

    saveOption(options: any) {
        this.working = true;
        this.clickSave.emit();
        this.orgSrv.uploadLogo(this.file.id, options);
        // this.appSrv.init();
        this.view = this.VIEW_MAIN;
    }

    cancelOption() {
        // console.log("cancel option");
        this.view = this.VIEW_MAIN;
        this.options = {...this.backupOptions};
    }

    uploadFile(file: File) {
        this.file = file;
        this.view = this.VIEW_EDIT;
        this.backupOptions = {...this.options};
        this.options = {};
    }



}
